<template>
    <div>

        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <Loader v-if="loading" />
        <div v-else-if="data.id">
            <form>
                <input type="hidden" name="id" v-model="data.id">
                <div class="form-group">
                    <label for="name" class="col-form-label">Ответ:</label>
                    <input type="text" class="form-control" id="name" name="name" v-model="data.name">
                    <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.name">
                        {{ errors.validationEdit.name[0] }}
                    </div>
                </div>
                <div class="form-group">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox"  name="correct" id="correct" v-model="data.correct">
                            <i class="fa fa-2x icon-checkbox"></i>
                            Это правильный ответ
                        </label>
                    </div>
                </div>

            </form>
            <button type="button" class="btn btn-primary" @click.prevent="editRecord()">Сохранить изменения</button>
            <div class="alert alert-danger" v-if="errors.edit">
                {{ errors.edit }}
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
export default {

    watch: {
        data: {
            deep: true,
            /*
            handler: function(val, oldVal) {
                //console.log(val, oldVal);
                // это щас не исп-ся, тут можно отслеживать изменение в data
                console.log('WATCH-325!');
            }
            */
        }
    },

    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', edit: '', validationEdit: {}},
            bcrumbs: [],
            title: 'Редактирование ответа',
        }
    },


    async mounted() {
       this.loadData()
    },

    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/answers/'+this.$route.params.id+'/edit')
                this.data = response.data.answer
                this.bcrumbs = response.data.bcrumbs
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },


        //
        // Edit record.
        //
        async editRecord() {
            this.errors.validationEdit = {}
            this.errors.edit = ''
            try {
                let response = await axios.post('admin/answers/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                if (response.status == 200) {
                    this.loadData()
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationEdit = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.edit = e.response.data.error
                }
                else {
                    this.errors.edit = "Неизвестная ошибка при редактировании записи."
                }
            }
        },

    },

    components: {
        Loader,
        BreadCrumbs,
        PageTitle
    },


  
}

</script>